import {type WysiwygPullQuoteComponentRecord} from '~/_generated/graphql'
import {SingleLineStructuredText} from '~/cms/components/SingleLineStructuredText'
import {type SingleLineStructuredTextFragment} from '~/cms/components/SingleLineStructuredText/_generated/fragment.graphql'

export function getPullQuoteProps({
  quote,
  author,
  context,
}: WysiwygPullQuoteComponentRecord) {
  return {
    quote: (
      <SingleLineStructuredText data={quote as SingleLineStructuredTextFragment} />
    ),
    author: author && (
      <SingleLineStructuredText data={author as SingleLineStructuredTextFragment} />
    ),
    context: context && (
      <SingleLineStructuredText data={context as SingleLineStructuredTextFragment} />
    ),
  }
}
